import React from 'react';
import { MAGIC_VALUES } from '../constants';

export default function MagicValuesPanel() {
  return (
    <div className="magic-values-panel">
      <h3>Magic Test Values</h3>
      <p>Use these special values to get predictable results:</p>
      <div className="magic-values-grid">
        {Object.entries(MAGIC_VALUES).map(([key, category]) => (
          <div key={key} className="magic-category">
            <h4>{category.title}</h4>
            <table className="workbench-table">
              <thead>
                <tr>
                  <th>Input</th>
                  <th>Result</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {category.values.map((v, i) => (
                  <tr key={i}>
                    <td><code className="workbench-code-inline">{v.input}</code></td>
                    <td>
                      <span className={`workbench-badge workbench-badge-${
                        v.result === 'clear' || v.result === 'match' || v.result === 'low' ? 'success' :
                        v.result === 'critical' || v.result === 'no_match' ? 'error' : 'warning'
                      }`}>
                        {v.result}
                      </span>
                    </td>
                    <td>{v.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    </div>
  );
}
